<template>
    <div>
        <div style="height:50px;">
            <el-input v-model="seachMac" size="medium" placeholder="请输入MAC地址" style="width:170px; margin-right:15px;float: left;"></el-input>
            <el-button @click="doSearch" type="primary" size="small" style="margin-right:20px;float: left;">搜索</el-button>
            <el-button @click="addMac" type="success" size="small" style="float: left;">添加Mac</el-button>
        </div>

        <el-table :data="tableData" v-loading="loading" style="width: 100%">
            <el-table-column prop="ID" label="ID" width="180"></el-table-column>
            <el-table-column prop="MAC" label="MAC地址" width="180"></el-table-column>
            <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
            <el-table-column prop="WriteStatus" label="烧写状态" :filters="writeStatusTags" :filter-method="filterWriteStatusTag">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.WriteStatus === '未烧写' ? 'danger' : 'success'"
                    disable-transitions>{{scope.row.WriteStatus}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="SyncStatus" label="是否同步到产线" :filters="syncStatusTags" :filter-method="filterSyncStatusTag">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.SyncStatus === '未同步' ? 'danger' : 'success'" disable-transitions>{{scope.row.SyncStatus}}</el-tag>
                </template>
            </el-table-column>

            <div slot="empty">暂无数据</div>
        </el-table>

        <el-dialog
            title="添加设备MAC"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <el-form label-position="rigth" label-width="100px" :model="formData">
                <el-form-item label="Mac地址">
                    <el-input v-model="formData.mac" style="width: 90%;"></el-input>
                </el-form-item>
            </el-form>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="doAddMac">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { WriteStatus, SyncStatus } from "../components/Index/data.js";

export default {
    props: {
        data: {}
    },
    components: {
    },
    data() {
        return {
            seachMac: "", //搜索框mac内容
            searchData: {
                mac: ""
            },
            dialogVisible: false,
            formData: {
                mac: ""
            },
            tableData: [],
            loading: false,
            writeStatusTags: [{text: WriteStatus[0], value: WriteStatus[0]}, {text: WriteStatus[1], value: WriteStatus[1]}],
            syncStatusTags: [{text: SyncStatus[0], value: SyncStatus[0]}, {text: SyncStatus[1], value: SyncStatus[1]}],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList () {
            this.loading = true;
            this.$http.get("repair-devices/", this.searchData, res => {
                this.loading = false;
                if (res.code == 200) {
                    let data = res.data;
                    for (let i in data) {
                        data[i].WriteStatus = WriteStatus[data[i].WriteStatus];
                        data[i].SyncStatus = SyncStatus[data[i].SyncStatus];
                    }
                    this.tableData = data;
                }
            });
        },
        doSearch () {
            this.searchData.mac = this.seachMac;
            this.getList();
        },
        addMac () {
            this.dialogVisible = true;
        },
        doAddMac () {
            this.$http.post("repair-devices/", this.formData, res => {
                let messageType = 'success'
                if (res.code === 200) {
                    messageType = 'success'
                } else {
                    messageType = 'error'
                }
                this.$message({
                    type: messageType,
                    message: res.msg
                });
                this.getList();
                this.handleClose();
            });
        },
        handleClose () {
            this.formData.mac = "";
            this.dialogVisible = false;
        },
        filterWriteStatusTag (value, row) {
            return row.WriteStatus === value;
        },
        filterSyncStatusTag (value, row) {
            return row.SyncStatus === value;
        }
    }
};
</script>
<style lang="less" scoped>

</style>
  